import { isUrlValid } from "../../../../utils/isUrlValid";

import { SocialNetwork } from "./types";
import { socialNetworksBaseUrl } from "./constants";

export function sanitizeSiteUrl(url?: string): string {
  if (!url) {
    return "";
  }

  const exp = /^(?:https?:\/\/)?(?:www\.)?/;
  return url.trim().replace(exp, "");
}

export function normalizeSocialLink(
  network: SocialNetwork,
  link?: string,
): string {
  if (!link) {
    return "";
  }

  const trimmedLink = link.trim();

  if (isUrlValid(trimmedLink)) {
    return trimmedLink;
  }

  return socialNetworksBaseUrl[network] + trimmedLink;
}
